module.exports = __webpack_public_path__ + "static/img/6.4387454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/6.png
// module id = cGbh
// module chunks = 0